'use strict';

/**
 * Пользовательские ошибки.
 * @constructor
 * @param {integer} code - Код ошибки.
 * @param {string} message - Текст сообщения об ошибке.
 * @param {string} name - Наименование ошибки.
 * @param {integer} level - Уровень ошибки:
 *     'EMERG': 0,   // Аварийная ошибка: прерывает выполнение кода: throw ....; принудительно выводится сообщение: alert(...); console.error(...);
 *     'ALERT': 1,   // Критическая ошибка: не прерывает выполнение кода; принудительно выводится сообщение: alert(...); console.error(...);
 *     'CRIT': 2,    // Критическая ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.error(...);
 *     'ERROR': 3,   // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.error(...);
 *     'WARN': 4,    // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.warn(...);
 *     'NOTICE': 5,  // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.notice(...);
 *     'INFO': 6,    // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.info(...);
 *     'DEBUG': 7    // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.debug(...);
 */
function CustomError(message, code, name, level) {
    this.level = (level || (level === 0)) ? level : this.levels.WARN;
    this.name = name || 'CustomError';
    this.code = code || -1;
    this.message = message || 'Неизвестная ошибка';
    this.status = this.code;      // deprecated;
    this.errorMsg = this.message; // deprecated;

    if (Error.captureStackTrace) {
        Error.captureStackTrace(this, CustomError);
    } else {
        this.stack = (new Error()).stack || 'Error.stack не поддерживается!';
    }

    if (this.level <= this.levels.ALERT) {
        alert(this.toString());
    }

    if (this.level <= this.levels.EMERG) {
        throw this;
    }

    switch (this.level) {
        case this.levels.WARN:   console.warn(this);   break;
        case this.levels.NOTICE: console.notice(this); break;
        case this.levels.INFO:   console.info(this);   break;
        case this.levels.DEBUG:  console.debug(this);  break;
        default:                 console.error(this);  break;
    }
}


CustomError.prototype = Object.create(Error.prototype);
CustomError.prototype.constructor = CustomError;
CustomError.prototype.toString = function(){ return this.name + ': ' + this.message; };
CustomError.prototype.levels = {
    'EMERG': 0,   // Аварийная ошибка: прерывает выполнение кода: throw ....; принудительно выводится сообщение: alert(...); console.error(...);
    'ALERT': 1,   // Критическая ошибка: не прерывает выполнение кода; принудительно выводится сообщение: alert(...); console.error(...);
    'CRIT': 2,    // Критическая ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.error(...);
    'ERROR': 3,   // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.error(...);
    'WARN': 4,    // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.warn(...);
    'NOTICE': 5,  // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.notice(...);
    'INFO': 6,    // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.info(...);
    'DEBUG': 7    // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.debug(...);
};

Object.freeze(CustomError.prototype.levels);



/**
 * Создает новый экземпляр пользовательской ошибки с заданными параметрами
 *
 * @param {integer} code - Код ошибки.
 * @param {string} message - Текст сообщения об ошибке.
 * @param {string} name - Наименование ошибки.
 * @param {integer} level - Уровень ошибки:
 *     'EMERG': 0,   // Аварийная ошибка: прерывает выполнение кода: throw ....; принудительно выводится сообщение: alert(...); console.error(...);
 *     'ALERT': 1,   // Критическая ошибка: не прерывает выполнение кода; принудительно выводится сообщение: alert(...); console.error(...);
 *     'CRIT': 2,    // Критическая ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.error(...);
 *     'ERROR': 3,   // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.error(...);
 *     'WARN': 4,    // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.warn(...);
 *     'NOTICE': 5,  // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.notice(...);
 *     'INFO': 6,    // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.info(...);
 *     'DEBUG': 7    // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.debug(...);
 * @return {CustomError} Новый объект CustomError.
 */
function _error(message, code, name, level) {
    if (code && !Number.isInteger(code)) {
        throw new CustomError('Неверный тип кода ошибки!');
    }
    if (!message) {
        throw new CustomError('Отсутствует текст ошибки!');
    }
    if (message && (Object.prototype.toString.call(message) !== '[object String]')) {
        throw new CustomError('Неверный тип текста ошибки!');
    }

    return new CustomError(message, code, name, level);
} /* _error */


/**
 * Создает новый экземпляр пользовательской ошибки с заданными параметрами
 *
 * @param {integer} code - Код ошибки.
 * @param {string} message - Текст сообщения об ошибке.
 * @param {string} name - Наименование ошибки.
 * @param {integer} level - Уровень ошибки:
 *     'EMERG': 0,   // Аварийная ошибка: прерывает выполнение кода: throw ....; принудительно выводится сообщение: alert(...); console.error(...);
 *     'ALERT': 1,   // Критическая ошибка: не прерывает выполнение кода; принудительно выводится сообщение: alert(...); console.error(...);
 *     'CRIT': 2,    // Критическая ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.error(...);
 *     'ERROR': 3,   // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.error(...);
 *     'WARN': 4,    // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.warn(...);
 *     'NOTICE': 5,  // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.notice(...);
 *     'INFO': 6,    // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.info(...);
 *     'DEBUG': 7    // Ошибка: не прерывает выполнение кода; принудительно не выводится сообщение; console.debug(...);
 * @return {Promise} возвращает объект Promise, который был отклонен по причине указанной в новой пользовательской ошибке (CustomError).
 */
function _error$(message, code, name, level) {
    return Promise.reject(_error(message, code, name, level));
} /* _error$ */


module.exports = {
    CustomError: CustomError,
    E: _error,
    E$: _error$
};


/**
 * Пример создания нового пользовательского класса наследуемого от предыдущего

function OtherCustomError(property) {
  CustomError.apply(this, arguments);
  this.name = 'OtherCustomError';
  this.message = 'Отсутствует свойство ' + property;
}

OtherCustomError.prototype = Object.create(CustomError.prototype);
OtherCustomError.prototype.constructor = OtherCustomError;
*/



//////////////////
// WEBPACK FOOTER
// ../node_modules/@itbelcom/custom-error/src/custom-error.js
// module id = 306
// module chunks = 0 1 2